export default __webpack_public_path__ + "static/media/p404.0e135265.png";